import type { Client } from 'openapi-fetch';

import type { EmsPaths } from '../api/ems';
import type { GeoPoint } from '../realtime/contracts';

const cache = new Map<string, string>();

export async function reverseGeocode(
  emsApi: Client<EmsPaths>,
  geoPoint: GeoPoint,
  language: string,
): Promise<string> {
  const cacheKey = `${geoPoint.latitude};${geoPoint.longitude}`;
  const cached = cache.get(cacheKey);
  if (cached !== undefined) {
    return cached;
  }

  const { data, response } = await emsApi.POST('/portal/v1/geocoding/reverse', {
    body: {
      geoPoint: { latitude: geoPoint.latitude, longitude: geoPoint.longitude },
      language,
    },
    parseAs: 'text',
  });

  if (data === undefined) {
    throw new Error(`Reverse geocoding failed (HTTP ${response.status})`);
  }

  cache.set(cacheKey, data);
  return data;
}
